export default __webpack_public_path__ + "static/media/hht2_storybook_08.cf52051f.png";